import BackButton from '@perpay-web/components/base/BackButton/BackButton';
import FocusContent from '@perpay-web/components/composite/FocusLayout/FocusContent';
import FocusFooter from '@perpay-web/components/composite/FocusLayout/FocusFooter';
import FocusHeader from '@perpay-web/components/composite/FocusLayout/FocusHeader';
import FocusLayout from '@perpay-web/components/composite/FocusLayout/FocusLayout';
import Stack from '@perpay-web/components/design-system/Stack/Stack';
import fraudAlert from '@perpay-web/fintech/assets/images/icons/fraudAlert.svg';
import { paths } from '@perpay-web/fintech/props/appPaths';

import styles from './IdentityVerificationRequired.scss';

const IdentityVerificationTemplate = ({ copyContent, footerContent }) => (
    <FocusLayout>
        <FocusHeader
            leftButtonElement={<BackButton href={paths.dashboard.path} />}
        />
        <FocusContent>
            <Stack className={styles['inner-stack']}>
                <img
                    alt='identity verification lock'
                    src={fraudAlert}
                    className={styles.image}
                />
                <Stack className={styles['inner-stack-tight']}>
                    <p className={styles.title}>
                        Identity Verification Required
                    </p>
                    {copyContent}
                </Stack>
            </Stack>
        </FocusContent>
        <FocusFooter>{footerContent}</FocusFooter>
    </FocusLayout>
);

export default IdentityVerificationTemplate;
